import type {StateCreator} from 'zustand'

export interface ComparisonInfoSlice {
  comparisonInfo: {
    baseOid: string
    headOid: string
    hideWhitespace: boolean
  }
  comparisonInfoActions: {
    updateWhitespace: (newVal: boolean) => void
  }
}

export interface ComparisonInfoSliceOpts {
  baseOid: string
  headOid: string
  hideWhitespace: boolean
}

export const createComparisonInfoSlice =
  ({
    baseOid,
    headOid,
    hideWhitespace,
  }: ComparisonInfoSliceOpts): StateCreator<ComparisonInfoSlice, [['zustand/devtools', never]]> =>
  set => {
    return {
      comparisonInfo: {
        baseOid,
        headOid,
        hideWhitespace,
      },
      comparisonInfoActions: {
        updateWhitespace: (newVal: boolean) =>
          set(
            (prevState: ComparisonInfoSlice) => ({
              comparisonInfo: {
                ...prevState.comparisonInfo,
                hideWhitespace: newVal,
              },
            }),
            undefined,
            'comparisonInfo#updateWhitespace',
          ),
      },
    }
  }
